

import "./empMngt.css";
import shape from "../../assets/service/shape.png";
import shape2Hrms from "../../assets/service/shape2Hrms.webp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BookDemoModal from "../../landing-hrms/sections/DemoModal";
import { useState } from "react";
import { Helmet } from "react-helmet";
import StarOutlineIcon from "@mui/icons-material/StarOutline";

const EmpManagement = () => {
    const [showContactModal, setShowContactModal] = useState(false);
    return (
        <>
            <Helmet>
                <title>
                    Scalable HRMS Software for Payroll & Employee Management | TechCognics
                </title>

                <meta
                    name="description"
                    content="Scale your HR operations with powerful HRMS software designed to simplify payroll processing, attendance tracking, and employee management as your business grows."
                />

                <meta
                    name="keywords"
                    content="scalable HRMS software, payroll automation, employee lifecycle management, HR software for growing companies, cloud HRMS, payroll management system"
                />

                <meta
                    property="og:title"
                    content="Scalable HRMS Software for Payroll & Employee Management"
                />

                <meta
                    property="og:description"
                    content="Built to simplify payroll and employee management at scale with automated HRMS software for fast-growing businesses."
                />

                <meta property="og:type" content="website" />
            </Helmet>

            <div class="why-choose-us__one section-padding">
                <div class="container">
                    <div class="row gy-4  emp-mngt">
                        <div class="col-xl-6 col-lg-7 col-md-12">
                            <div class="why-choose-us__one-left">
                                <div class="why-choose-us__one-title text-start">
                                    <div className="text-start feature-heading" style={{ color: '#0F4F93' }}>Built to Simplify Payroll and Employee Management at Scale</div>
                                </div>
                                <div class="why-choose-us__one-quality">
                                    <div class="why-choose-us__one-quality-single ">
                                        <div className="why-choose-us__one-quality-single-content text-start">
                                            <div className="service">
                                                <StarOutlineIcon className="service-icon star" />
                                                <span className="service-text">
                                                    Automated payroll software with statutory accuracy
                                                </span>
                                            </div>

                                            <div className="service">
                                                <StarOutlineIcon className="service-icon star" />
                                                <span className="service-text">
                                                    Real-time attendance and payroll integration
                                                </span>
                                            </div>

                                            <div className="service">
                                                <StarOutlineIcon className="service-icon star" />
                                                <span className="service-text">
                                                    Centralized employee management processes
                                                </span>
                                            </div>

                                            <div className="service">
                                                <StarOutlineIcon className="service-icon star" />
                                                <span className="service-text">
                                                    Faster HR operations with fewer manual touchpoints
                                                </span>
                                            </div>

                                            <div className="service">
                                                <StarOutlineIcon className="service-icon star" />
                                                <span className="service-text">
                                                    Reliable data for confident HR decisions
                                                </span>
                                            </div>

                                            <div className="service">
                                                <StarOutlineIcon className="service-icon star" />
                                                <span className="service-text">
                                                    Your HR team works smarter, not harder
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                    <button onClick={() => setShowContactModal(true)} className="btn-two">
                                        Book Demo <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5 offset-xl-1 col-lg-6 col-md-12">
                            <div class="why-choose-us__one-image">
                                <div class="why-choose-us__one-image-shape">
                                    <div class="shape shape-1 animate-x-axis"></div>
                                    <div class="shape shape-2 animate-x-axis"></div>
                                    <img src={shape} alt="shape" class="shape shape-3 animate-y-axis" />
                                </div>
                                <img src={shape2Hrms} alt="image" />

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <BookDemoModal
                showDemo={showContactModal}
                handleDemoClose={() => setShowContactModal(false)}
            />
        </>

    );
};

export default EmpManagement;

